import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { TextElement } from "@/react/types/Element";

export const elementToBlock = (element: TextElement): BaseBlock => ({
  id: element.id.toString(),
  type: "FormParagraphBlock",
  props: {
    value: {
      prop: "other",
      type: "string",
      value: element.attributes.value,
    },
  },
  meta: {
    elementType: "text",
    textType: element.attributes.text_type,
    elementId: element.id,
    position: element.position,
    elementableId: element.elementable_id,
    parentElementId: element.parent_element_id,
  },
});
